export const pageIds = {
  home: "home",
  about: "about",
  experience: "experience",
  projects: "projects",
  skills: "skills",
  teams: "teams",
  contactUs: "contactUs",
};
